import { useNavigate } from "react-router-dom";
import { getUser } from "@api/useAuth";
import { Button } from "@common";
import { clearAuthCookies } from "@utils/cookies";

export default function AccountStatus() {
  const nav = useNavigate();
  const user = getUser();
  const status = user?.status || "inactive";

  function handleSignOut() {
    clearAuthCookies();
    nav("/login", { replace: true });
  }

  const config = {
    pending: {
      title: "Account Pending Verification",
      message:
        "Your account is awaiting approval from an administrator. You'll be able to access the system once approved.",
      color: "text-palette-amber-badge",
      bg: "bg-palette-amber-soft",
      border: "border-palette-amber-border",
    },
    inactive: {
      title: "Account Inactive",
      message:
        "Your account is currently inactive. Please contact an administrator for assistance.",
      color: "text-palette-gray-badge",
      bg: "bg-palette-gray-soft",
      border: "border-palette-gray-divider",
    },
    suspended: {
      title: "Account Suspended",
      message:
        "Your account has been suspended. Please contact an administrator for more information.",
      color: "text-palette-red-badge",
      bg: "bg-palette-red-soft",
      border: "border-palette-red-border",
    },
  };

  const c = config[status] || config.inactive;

  return (
    <div className="flex items-center justify-center min-h-screen bg-palette-gray-subtle">
      <div className={`max-w-md w-full mx-4 p-8 rounded-2xl border ${c.bg} ${c.border}`}>
        <h1 className={`text-xl font-semibold mb-3 ${c.color}`}>{c.title}</h1>
        <p className="text-sm text-palette-gray-badge mb-6">{c.message}</p>
        <Button variant="outline" onClick={handleSignOut} className="w-full">
          Sign Out
        </Button>
      </div>
    </div>
  );
}
